import { removeSaveSearch, SaveApiResMessage } from '@/actions';
import { fDate } from '@/actions/Helper';
import { Icons } from '@/assets';
import { Icon } from '@/components/Icon';
import LoadingV2 from '@/components/Loading';
import { TableV3 } from '@/components/TableV3';
import IconButton from '@/ctComponents/IconButton';
import Modal from '@/ctComponents/Modal';
import React, { useState } from 'react';

export const SavedSearchesV2 = ({
  loading,
  savedSearches,
  refetchSavesSearches,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState({
    show: false,
    item: null,
  });

  const columns = [
    {
      field: 'cabin.specifications.size_type',
      label: 'Size',
      align: 'center',
      component: (row) => row.cabin.specifications.size_type,
      sortValue: (row) => row.cabin.specifications.size_type,
    },

    {
      field: 'cabin.company.name',
      label: 'SSL',
      align: 'center',
      sortValue: (row) => row.cabin.company.name,
      component: (row) => row.cabin.company.name,
    },

    {
      field: 'city',
      label: 'Location',
      align: 'center',
      component: (row) => row.city,
      sortValue: (row) => row.city,
    },

    {
      field: 'date',
      label: 'Date',
      align: 'center',
      component: (row) => <>{fDate(row.date)}</>,
      sortValue: (row) => row.date,
    },
    {
      field: 'updated_at',
      label: 'Expire Dae',
      align: 'center',
      component: (row) => <>{fDate(row.updated_at)}</>,
      sortValue: (row) => row.updated_at,
    },
    {
      field: '',
      label: 'Action',
      align: 'center',
      component: (row) => (
        <div>
          <IconButton
            color="#FB3748"
            icon="deleteIcon"
            text=""
            onClick={() => handleOpenDeleteModal(row)}
            style={{
              border: 'none',
            }}
          />
        </div>
      ),
    },
  ];

  const handleOpenDeleteModal = (row) => {
    setShowDeleteModal({
      show: true,
      item: row,
    });
  };

  const handleSubmit = () => {
    removeSaveSearch(showDeleteModal.item.id)
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Successfully Deleted',
          mode: 'success',
        });
        refetchSavesSearches();
        setShowDeleteModal({
          show: false,
          item: null,
        });
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  return (
    <>
      <div className={`m-auto ${savedSearches?.length > 1 ? 'pr-2' : ''}`}>
        {savedSearches?.length === 0 ? (
          <div className="flex flex-col items-center justify-center">
            <Icon src={Icons.infoEmptyList} width={24} height={24} />
            <p className="text-inactive-text font-bold text-lg m-0 mt-4 mb-1">
              No Items in Watchlist
            </p>
            <p className=" text-inactive-text text-base m-0">
              Empty containers you add to your watchlist will appear here, and
              you’ll be notified when available.
            </p>
          </div>
        ) : (
          <>
            {!(loading && savedSearches?.length === 0) && (
              <TableV3
                headers={columns}
                data={savedSearches || []}
                emptyMessage=""
                minWidth="unset"
                stickyHeader={false}
                appHeaderHeight={64}
              />
            )}

            {loading &&
              (savedSearches?.length === 0 ||
                (savedSearches && savedSearches.length > 0)) && (
                <div className="flex justify-center py-4">
                  <LoadingV2 />
                </div>
              )}
          </>
        )}
      </div>
      <Modal
        minWidth="unset"
        noX
        show={showDeleteModal.show}
        children={
          <span className="mt-6 text-center w-full md:min-w-xl">
            Are you sure you want to Remove search history?
          </span>
        }
        submitText={'Yes, Remove'}
        icon={'deleteIcon'}
        title={'Remove Search History'}
        setShow={(value) => {
          setShowDeleteModal({
            show: value,
            item: showDeleteModal.item,
          });
        }}
        submit={handleSubmit}
        loadingbutton={loading}
      />
    </>
  );
};

export default SavedSearchesV2;
